export default __webpack_public_path__ + "images/0x2cab3abfc1670d1a452df502e216a66883cdf079.png";